angular.module('ccaavailableModule', [

    'tmh.dynamicLocale',

    'ui.bootstrap',

    'payments.components.paymentProviderButtons',
    'angular.filter',

    'cca.components.dailyPreferenceSelector',
    'cca.components.ccaGroupInstantBookSelection',
    'cca.services.ccaService',
    'ccaAvailable.services.availableRepository',
    'ccaAvailable.services.organisationAvailableRepository',
    'ccaAvailable.services.ccaActionsService',
    'ccaAvailable.transport.timeslot.ccaTimeslot',

    'events.components.bookingCountdown',
    'events.directives.timeSlottedEventPicker',
    'events.constants',

    'groups.services.groupService',

    'payments.constants',
    'payments.components.paymentResult',
    'payments.services.paymentsService',
    'person.services',

    'shared.components.sbIcon',
    'shared.components.sbColumnHeader',
    'shared.components.sbAvatar',
    'shared.components.sbModalHeader',
    'shared.components.sbLabelList',
    'shared.components.sbTitleBar',

    'shared.controllers.confirmationPopup',

    'shared.directives.fixedFirstColumn',
    'shared.directives.fixedTableHeaders',
    'shared.directives.updateLanguage',
    'shared.directives.cloakTranslate',
    'shared.directives.ngBindHtmlDataLabelAttr',
    'shared.directives.ngBindHtmlPlaceholder',
    'shared.directives.ngBindHtmlTitleAttr',
    'shared.components.sbSubmitButton',

    'shared.filters.decoded',

    'shared.services.authInterceptor',
    'shared.services.simpleAlertService',
    'shared.services.blobStoragePhotosService',
    'shared.services.toastService',

    'userForm.components.capture',
    'userForm.components.tabcapture',
    'ng1StateDefinitionModule'
]);

angular.module('ccaavailableModule').constant('EventCategorySystemUsageType', {
    None: 0,
    CCA: 1,
    Membership: 2,
    Fee: 4,
    ParentsEvening: 8,
    Task: 16,
    Transport: 32
});

angular.module('ccaavailableModule').config([
    'ng1StateDefinitionProvider',
    function(ng1StateDefinitionProvider){

        const ng1State = ng1StateDefinitionProvider.$get();

        const moduleName = 'CcaAvailable';

        ng1State.state(moduleName, 'ccaAvailable', {
            url: ''
        })
        ng1State.state(moduleName, 'ccaDetails', {
            url: '/Details/:signUpId'
        })
        ng1State.state(moduleName, 'ccaReview', {
            url: '/Review/:signUpReviewId'
        })
        ng1State.state(moduleName, 'ccaToJoin', {
            url: '/ToJoin/:signUpId'
        })

        ng1State.state(moduleName, 'ccaSelection', {
            url: '/Selection/:signUpId/:pupilId'
        })

        ng1State.state(moduleName, 'ccaSelectionParentsEvening', {
            url: '/SelectionParentsEvening/:signUpId/:pupilId'
        })

        ng1State.state(moduleName, 'ccaConfirmation', {
            url: '/Confirmation/:signUpId'
        })
        ng1State.state(moduleName, 'paymentComplete', {
            url: '/paymentComplete',
            component: 'paymentResult',
            // params: {
            //     isSuccess: null,
            //     message: null,
            //     merchantReference: null,
            //     items: null
            // },
            // resolve: {
            //     isSuccess: function ($transition$) {
            //         return $transition$.params().isSuccess;
            //     },
            //     message: function ($transition$) {
            //         return $transition$.params().message;
            //     },
            //     merchantReference: function ($transition$) {
            //         return $transition$.params().merchantReference;
            //     },
            //     items: function ($transition$) {
            //         return $transition$.params().items;
            //     }
            // }
        })
    }
])

.filter('removeHTMLTags', function () {
    return function (text) {
        return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
})

angular.module('ccaavailableModule')
.component('ng1CcaAvailableSelectionParentsEvening', {
    template: [
        '<div class="text-danger text-right bookable-events-banner banner sticky sticky-top"',
        '     ng-if="$ctrl.unconfirmedBookingCount > 0 || $ctrl.hasBookingSelectionTimedOut">',
        '    <div class="mb-3">',
        '        <booking-countdown minutes="$ctrl.timeRemainingMins" seconds="$ctrl.timeRemainingSecs"',
        '            on-timeout="$ctrl.onTimeoutBooking" on-update-time-remaining="$ctrl.onUpdateTimeRemaining">',
        '        </booking-countdown>',
        '    </div>',
        '</div>',
        '<time-slotted-event-picker',
        '    sign-up="$ctrl.signUp"',
        '    events-data="$ctrl.eventsData"',
        '    your-events="$ctrl.yourEvents"',
        '    pupils="$ctrl.pupils"',
        '    unconfirmed-booking-count="$ctrl.unconfirmedBookingCount"',
        '    selected-quantity-changing="$ctrl.selectedQuantityChanging"',
        '    add-booking-handler="$ctrl.addBookingHandler"',
        '    remove-booking-handler="$ctrl.removeBookingHandler"',
        '    cancel-confirmed-booking-handler="$ctrl.cancelBookingHandler"',
        '    on-reload-events="$ctrl.reloadEvents()"',
        '    has-booking-selection-timed-out="$ctrl.hasBookingSelectionTimedOut">',
        '</time-slotted-event-picker>'
    ].join(' '),
    bindings: {
        signUpId: '<',
        pupilId: '<',
        onYourEventsChange: '&',
        onBookingTimedOut: '&'
    },
    controller: ['$scope', 'availableRepository', 'ccaService', function ($scope, availableRepository, ccaService) {
        var $ctrl = this;

        $ctrl.signUp = {};
        $ctrl.eventsData = null;
        $ctrl.yourEvents = [];
        $ctrl.pupils = [];
        $ctrl.unconfirmedBookingCount = 0;
        $ctrl.hasBookingSelectionTimedOut = false;
        $ctrl.minutesUntilBookingExpiry = undefined;
        $ctrl.timeRemainingMins = undefined;
        $ctrl.timeRemainingSecs = 0;
        $ctrl.selectedQuantityChanging = false;

        $ctrl.$onInit = function () {
            availableRepository.getSignUp($ctrl.signUpId).then(function (signUp) {
                $ctrl.signUp = signUp;
            });
            $ctrl.getEvents(false);
        };

        $ctrl.$postLink = function () {
            $scope.$watchCollection(
                function () { return $ctrl.yourEvents; },
                function (newVal) {
                    if ($ctrl.onYourEventsChange) {
                        $ctrl.onYourEventsChange({ yourEvents: newVal || [], pupils: $ctrl.pupils });
                    }
                }
            );
        };

        $ctrl.getEvents = function (isReload) {
            availableRepository.getSignUpEvents($ctrl.signUpId, $ctrl.pupilId).then(function (eventsData) {
                $ctrl.eventsData = eventsData;
                $ctrl.pupils = eventsData.pupils || [];
                $ctrl.minutesUntilBookingExpiry = eventsData.minutesUntilBookingExpiry;
                $ctrl.resetTimeRemaining();
            });
        };

        $ctrl.reloadEvents = function () {
            $ctrl.getEvents(true);
        };

        $ctrl.addBookingHandler = function (pupilObj, eventObj) {
            $ctrl.selectedQuantityChanging = true;
            return availableRepository.postToggleBookingLite(pupilObj, eventObj)
                .then(function (responseDto) {
                    $ctrl.handleToggleBookingLiteResponse(responseDto);
                    return responseDto;
                });
        };

        $ctrl.removeBookingHandler = function (pupilObj, eventObj) {
            return availableRepository.postToggleBookingLite(pupilObj, eventObj)
                .then(function (responseDto) {
                    $ctrl.handleToggleBookingLiteResponse(responseDto);
                    return responseDto;
                });
        };

        $ctrl.handleToggleBookingLiteResponse = function (responseDto) {
            if ($ctrl.eventsData && $ctrl.eventsData.availableEvents) {
                var calendarEventDto = $ctrl.eventsData.availableEvents.find(function (x) { return x.calendarEventId == responseDto.calendarEventId; });
                if (calendarEventDto && calendarEventDto.pupils) {
                    var pupilDto = calendarEventDto.pupils.find(function (x) { return x.personId == responseDto.personId; });
                    if (pupilDto) {
                        pupilDto.status = responseDto.bookingStatusId;
                        pupilDto.expiryTimestampUtc = responseDto.expiryTimestampUtc;
                    }
                }
            }
            $ctrl.resetTimeRemaining();
        };

        $ctrl.cancelBookingHandler = function (pupilObj, eventObj) {
            return availableRepository.cancelAAConfirmedBooking(pupilObj, eventObj)
                .then(function (data) { return data.isError ? false : true; });
        };

        $ctrl.resetTimeRemaining = function () {
            if (typeof $ctrl.minutesUntilBookingExpiry === 'undefined') {
                $ctrl.minutesUntilBookingExpiry = $ctrl.eventsData.minutesUntilBookingExpiry;
            }
            var bookingExpiryInfo = ccaService.getBookingExpiryInfo($ctrl.eventsData.availableEvents);
            $ctrl.oldestBookingExpiry = bookingExpiryInfo.oldestBookingExpiry;
            if ($ctrl.oldestBookingExpiry) {
                $ctrl.timeRemainingMins = moment.utc(bookingExpiryInfo.timeRemaining).get('minutes');
                $ctrl.timeRemainingSecs = moment.utc(bookingExpiryInfo.timeRemaining).get('seconds');
            } else {
                var minutesToShowForCountdown = $ctrl.minutesUntilBookingExpiry > 5
                    ? $ctrl.minutesUntilBookingExpiry - 5
                    : $ctrl.minutesUntilBookingExpiry;
                $ctrl.timeRemainingMins = minutesToShowForCountdown;
                $ctrl.timeRemainingSecs = 0;
            }
        };

        $ctrl.onTimeoutBooking = function () {
            $ctrl.timeOutBooking();
            $ctrl.deselectAllStudents();
            if ($ctrl.onBookingTimedOut) {
                $ctrl.onBookingTimedOut();
            }
        };

        $ctrl.onUpdateTimeRemaining = function (timeRemaining) {
            $ctrl.timeRemaining = timeRemaining;
        };

        $ctrl.timeOutBooking = function () {
            $ctrl.hasBookingSelectionTimedOut = true;
            $ctrl.timeRemainingMins = 0;
            $ctrl.timeRemainingSecs = 0;

            var timeOutBookingsRequest = {
                signUpId: $ctrl.signUp.ccaSignUpId,
                timeOutBookingRequests: []
            };

            $ctrl.eventsData.availableEvents.forEach(function (signUpEvent) {
                var selectedStudentIds = [];
                signUpEvent.pupils.forEach(function (student) {
                    if (student.status == ccaService.bookingStatusEnum.Reserved) {
                        selectedStudentIds.push(student.personId);
                    }
                });
                if (selectedStudentIds.length > 0) {
                    timeOutBookingsRequest.timeOutBookingRequests.push({
                        calendarEventId: signUpEvent.calendarEventId,
                        selectedStudentIds: selectedStudentIds
                    });
                }
            });

            ccaService.timeOutSelectedStudentBookings(timeOutBookingsRequest);
        };

        $ctrl.deselectAllStudents = function () {
            var selectedStudents = $ctrl.eventsData.availableEvents
                .flatMap(function (x) { return x.pupils.filter(function (p) { return p.status == ccaService.bookingStatusEnum.Reserved; }); });
            selectedStudents.forEach(function (y) {
                y.expiryTimestampUtc = null;
                y.status = ccaService.bookingStatusEnum.TimedOut;
                y.selectionCount = 0;
            });
        };
    }]
});

